<template>
  <div style='background:white;' class='' v-loading='loading'>
  
    <el-dialog class='gDia' v-loading='loading' :title="$t('lin_global.bdsb')" v-model="dialogVisible" size=''>
      <el-row><el-col :span='10'><div style='width:100%;background:none;text-align:left;'>
        <el-input
        :placeholder="$t('app_searchTerminal')"
        icon="search"
        :on-icon-click="srchDevice"
        @keyup.enter.native='srchDevice'
        style=''
        v-model="srchValue">
        </el-input>
      </div></el-col></el-row>


      <el-table
      :data="tableData"
      border
      class='gTopMg'
      tooltip-effect="dark"
      style="width: 100%">
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_terNo')"
          width="150">
        </el-table-column>
        <!-- <el-table-column
          align='center'
          prop="terminalName"
          :label="$t('app_terName')"
          width="130">
        </el-table-column> -->
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')"
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  @click='pushInstall(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('lin_btn.bind')" placement="top">
              <el-button type='text'  @click='bindOp(scope.row)'><i class="fa fa-chain" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
        <!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

      </div>
    </el-dialog>

    <el-button @click='editCf' type="primary">{{$t('app_editsecrrule')}}</el-button>
    
    <div v-show="true" class='gPageBorder gTopMg'>
      <div style='display:inline-block;width:calc(100% - 48px);height:100%;margin-bottom:0px;background:none;padding:0 0px 12px 24px'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{config ? config.keyName : ''}}</button>
        </div>
        <div style='height:22px;'>
          <table class='lcpush'>
            <tr>
              <td>
                <label class='dt-word-title'>{{$t('app_secrdesc')}}：</label>
                <label class='dt-word-main'>{{config? config.memo : ''}}</label>
              </td>
              
            </tr>
            
          </table>
        </div>
       
      </div>
    </div>

    <div class='gPageBorder gTopMg' v-show="true" style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_secrdvlist')}} </p>

      <el-row>
        <el-col :span='12'>
          <div class='gSgLeftBtn'>
            <el-button  v-show="true"  @click="addTer" type='primary'  class=''>{{$t('terminal.list.add_btn')}}</el-button>
          </div>
        </el-col>


        <el-col :span="4">
            <div class='gCtrl'>
              <el-select  v-model="bindVl" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in bindSts"
                  :key="item.vl"
                  :label="item.lb"
                  :value="item.vl">
                </el-option>
              </el-select>
            </div>
          </el-col>

        <el-col :span="4">
            <div class='gCtrl'>
              <!-- <el-select  v-model="appType" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in appTypes"
                  :key="item.appClassifyId"
                  :label="item.appClassifyName"
                  :value="item.appClassifyId">
                </el-option>
              </el-select> -->
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col>
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_name') + ' & ' + $t('app_number')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
      </el-row>

      
      
      <el-table
        :data="hiss"
        border
        class='gTopMg'
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="terminalName"
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="terminalNo"
          width=''
          :label="$t('app_deviceNo')">
        </el-table-column>


        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</label>
          </template>
        </el-table-column> -->


        <el-table-column
          header-align='center'
          align='center'
          prop="mechName"
          width=''
          :label="$t('app_distributor')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          :formatter="showBindSt"
          width=''
          :label="$t('app_appconfigst')">
        </el-table-column>
       
        <el-table-column
          header-align='center'
          align='center'
          fformatter="dateFormat"
          prop="opeTime"
          width='170'
          :label="$t('app_applytime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='86'
          :label="$t('app_operate')">
          <template slot-scope='scope' >
            

            

            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top" v-show='scope.row.status != 1'>
              <el-button type='text' @click='unbind(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>

       


          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style='gPgDiv'>

        <el-pagination
        class='gPg'
        @current-change="pageChange"
        @size-change="pageSize"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
        </el-pagination>

      </div>
    </div>
  

  </div>
</template>

<style>
  .dt-word-main{color:rgb(72,87,106)}
  .dt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .dt-launch{width:100%;height:100%;background:none;}
    .dt-launch td{width:20%;}

 
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import df from '../../../assets/df.png'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default {
    data () {
      var _this = this
      return {
        mechanismData: {
          callback (value) {
            _this.mech = value
            // that.selectChange(value)
            _this.getList()
          }
        },
        mech: '',
        srchValue: '',
        detail: '',
        dialogVisible: false,
        mapType: {
          '0': this.$t('app_bdmap'),
          '1': 'Google' + this.$t('app_map')
        },
        ctrlType: {
          '0': this.$t('app_off1'),
          '1': this.$t('app_on1'),
        },
        bindSt: {
          '0': this.$t('app_waitupdate'),
          '1': this.$t('app_updateSuccess'),
          '2': this.$t('app_updateFail')
        },
        bindSts: [
          {vl:'', lb: this.$t('app_allstatus')},
          {vl:'0', lb: this.$t('app_waitupdate')},
          {vl:'1', lb: this.$t('app_updateSuccess')},
          {vl:'2', lb: this.$t('app_updateFail')}
        ],
        bindVl: '',
        config: '',
        captures: [],
        loading: 0,
        tableData: [],
        tags: [],
        page: 1,
        index:1,
        hiss: [],
        pageTotal: 0
      }
    },
    components: {
      MechanismSelector
    },
    computed: {
    
      showUploadNew () {
        //console.log('ccc', this.config.data)
        if (this.config) {
          if (this.config.isoperate === 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      editCf () {
        this.$setWObj('keyEdit', {type: 1, data: this.config, isSetLc: true})
        this.$router.push({path: '/keyrule/detail/edit'})
      },
      showBindSt (row) {
        return this.bindSt[row.useStatus]
      },
      bindOp (row) {
        this.loading = 1
        this.$keyAddDevice(row.terminalId, this.config.id, res => {
          this.loading = 0
          if (res.status === 200) {
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        }) 
      },
      query () {
        this.getList()
      },
      srchDevice () {
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        this.loading = 1
        this.$keyblist(this.index, this.$gRow, localStorage.mechanismId, vl, (res) => {
          console.log('dv', res)
          this.loading = 0
          if (res.data) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      addTer () {
        this.dialogVisible=true
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          console.log(obj)
          this.$delFstRecord(obj.id, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      unbind (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          
          this.$keyDelDevice(row.id, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      editApp (row) {
        this.$setWObj('filestEdit', {type: 1, data: row})
        this.$router.push({path: '/keyrule/detail/edit'})
      },
     
      getList () {
        this.loading = 1
        var mech = this.mech //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        var status = this.bindVl


        this.$keyDeviceBindList(this.page, this.$gRow, mech, name, status, this.config.id, res => {
          
          this.loading = 0
          if (res.status === 200) {
            this.pageTotal = res.total
            this.hiss = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      getDetail () {
        this.loading = 1
        this.$getFstDetail(this.config.data.recordId, (res) => {
          this.loading = 0
          if (res.status === 200) {
            
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        // this.getDevices()
        this.getList()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
     


      delHis (row) {
        
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = 1
          this.$delLauncherHistory(row.versionid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getHistory()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          
        }).catch(() => {
        })
        
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
          //return path
        } else {
          return ''
        }
      },

      getHistory () {
        if (this.config.status !== '2') {
          return
        }
        this.loading = 1
        this.$launcherHistory(this.config.launcherid, (res) => {
          console.log('his', res)
          this.loading = 0
          if (res.status === 200) {
            this.tableData = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
        
        
      },
      uploadNew () {
        // this.$t('menu.sysManageSub.launchNewVer')
        var obj = {type: 2, data: this.config}
        var key = 'launcherEdit'
        this.$setWObj(key, obj)
        this.$router.push({path: '/launch-newver'})
      },
      init () {
        this.config = this.$getWObj().keyruleDetail
        // if (this.config.appPackage) {
        //   this.tags = this.config.appPackage.split(',')
        // }
        console.log('cc', this.config)
        // this.getHistory()
        this.getList()
        this.getDevices()
      }
     
    },
    mounted () {
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?35df1f20